'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function getObserversForMessage(emitter, msg) {
	var observers = emitter.__observers[msg];
	if (!Array.isArray(observers)) {
		observers = emitter.__observers[msg] = [];
	}
	return observers;
}

var Emitter = (function () {
	function Emitter() {
		_classCallCheck(this, Emitter);

		Object.defineProperty(this, '__observers', {
			value: {},
			enumerable: false
		});
	}

	_createClass(Emitter, [{
		key: 'destroy',
		value: function destroy() {}
	}, {
		key: 'on',
		value: function on(msg, fn) {
			var observers = getObserversForMessage(this, msg);
			if (observers && observers.indexOf(fn) === -1) {
				observers.push(fn);
			}
		}
	}, {
		key: 'once',
		value: function once(msg, fn) {
			this.on(msg, function () {
				fn.apply(undefined, arguments);
				return false;
			});
		}
	}, {
		key: 'off',
		value: function off(msg, fn) {
			var observers = getObserversForMessage(this, msg);
			if (observers) {
				var index = observers.indexOf(fn);
				if (index > -1) {
					observers.splice(index, 1);
				}
			}
		}
	}, {
		key: 'emit',
		value: function emit(msg) {
			var _this = this;

			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}

			var observers = getObserversForMessage(this, msg);
			if (observers) {
				observers.slice(0).forEach(function (fn) {
					var result = fn.apply(undefined, args);
					if (result === false) {
						_this.off(msg, fn);
					}
				});
			}
		}
	}]);

	return Emitter;
})();

exports['default'] = Emitter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/emitter.js
// module id = d+A2
// module chunks = 15